const Company = {
  Employees: "Company.Employees",
  Salaries: "Company.Salaries",
  Deviations: "Company.Deviations",
  Commissions: "Company.Commissions",
  Shareholders: "Company.Shareholders",
  OwnershipStructure: "Company.OwnershipStructure",
  BusinessDescription: "Company.BusinessDescription",
  FTax: "Company.FTax",
  EmployerRegistere: "Company.EmployerRegistere",
  Board: "Company.Board",
  ShareCapital: "Company.ShareCapital",
  NumberOfShares: "Company.NumberOfShares",
  VatPeriodType_0: "Company.VatPeriodType_0",
  VatPeriodType_1: "Company.VatPeriodType_1",
  VatPeriodType_2: "Company.VatPeriodType_2",
  VatPeriodType_3: "Company.VatPeriodType_3",
  LatestKnownOwnerPicture: "Company.LatestKnownOwnerPicture",
  LastKnownOwnerStructure: "Company.LastKnownOwnerStructure",
  }
export default Company;